export enum BookingTypeEnum {
  INTERNAL = 'Internal',
  EXTERNAL = 'External',
  TEL = 'Telephone',
  EMAIL = 'Email',
  VARDEN = 'InternalBookingSystem',
  HOMEPAGE = 'Homepage',
  ERRANDSYSTEM = 'ErrandSystem',
}

export enum BookingTypeIdEnum {
  EMAIL = 1,
  TEL = 2,
  INTERNAL = 3,
  EXTERNAL = 4,
  VARDEN = 5,
  HOMEPAGE = 7,
  ERRANDSYSTEM = 8,
}

export enum BookingActionEnum {
  URL = 'Url',
  POPUP = 'Popup',
  CUSTOM_POPUP = 'CustomPopup',
  VARDEN_BOOKING = 'VardenBooking',
}

export enum OpenHourFieldNameTypesEnum {
  SURGERY = 'surgeryHours',
  TELEPHONE = 'telephoneHours',
  DROPIN = 'dropInHours',
  VISITINGHOURS = 'visitingHours',
}

export enum OpenHourTypeLabelsEnum {
  SURGERY = 'Öppettider',
  TELEPHONE = 'Telefontider',
  DROPIN = 'Drop-in-tider',
  VISITINGHOURS = 'Besökstider',
}

export enum OpenHourTypesSortValueEnum {
  SURGERY = 1,
  TELEPHONE = 2,
  DROPIN = 3,
}

export enum BookingButtonColorEnum {
  GREEN = 'green',
  LIGHT_GREEN = 'lightgreen',
}
